export default "__VITE_ASSET__DmFSNOt6__"